<template>
  <div class="pageDesign-container">
    <page-designer ref="vfDesigner">
      <template #customToolButtons>
        <el-button type="text" icon="el-icon-delete" @click="clearFormWidget">清空</el-button>
        <el-button type="text" icon="el-icon-finished" @click="saveFormJson">保存</el-button>
      </template>
    </page-designer>
  </div>
</template>

<script>
// import
import { requestTableListAndFromList } from '@/CommonDP/service/listFlow-service';
import metadataService from "@/CommonDP/service/metadata-service.js";
import { mapState } from "vuex";
import { getListConfigJSONByFormCode } from '@/CommonDP/service/listFlow-service';
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import _ from 'lodash';
import { componentDicList } from '@/CommonDP/exportComponentList';


export default {
  data () {
    return {
      checkPermission,
      pageInfo: {}
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    $vformRef () {
      return this.$refs.vfDesigner;
    }
  },
  provide () {
    return {
      getPageInfo: () => this.pageInfo,
      queryTableListAndFromList: this.queryTableListAndFromList,
      previewMode: true,
      componentDicList,
    };
  },
  mounted () {
    // this.init()
  },
  methods: {
    async init (data) {
      this.loading = true;
      this.pageInfo = data;
      this.hasFormJson = await this.queryDynFormJson(data.formCode);
      await this.$nextTick();
      if (this.hasFormJson) {
        this.$vformRef.setFormJson(this.hasFormJson);
      }
      this.loading = false;
    },
    // 查询是否有json 数据
    async queryDynFormJson (formCode) {
      const res = await getListConfigJSONByFormCode(formCode);
      return JSON.parse(res.data.json) || "";
    },
    // 保存表单
    async saveFormJson () {
      const formJson = this.$vformRef.getFormJson();
      try {
        this.loading = true;
        await metadataService.customDesignSave(this.pageInfo.groupId, { json: JSON.stringify(formJson) });
        this.$message.success("自定义页面已保存！");
        this.$emit("initTree");
      } finally {
        this.loading = false;
      }
    },
    clearFormWidget () {
      this.$confirm(`清空后被永久删除，请确认?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.loading = true;
          this.$vformRef.clearDesigner();
          await metadataService.dynFormDesignDelete(this.pageInfo.groupId);
          this.$success("清空成功");
          this.$emit("initTree");
          this.loading = false;
        })
        .catch(() => {
          console.error(error);
        });
    },
    queryTableListAndFromList (groupId) {
      return requestTableListAndFromList(groupId);
    },
    refreshList () {
      this.$emit('refreshList');
    },

    initTree () {
      this.$emit('initTree');
    }

  }

};
</script>

<style scoped>
@import "../../../../../lib/pageDesign/pageDesigner.css";
</style>

<style lang="scss" scoped>
.pageDesign-container {
  width: 100%;
  height: 100%;
  overflow: hidden;

  /deep/.main-container {
    margin-left: 0 !important;
  }
}

/deep/.el-form-item {
  margin-bottom: 10px;
}

.wrap {
  width: 100%;
  height: 100%;

  /deep/ .el-table--border .el-table__cell:first-child .cell {
    padding-left: 5px;
  }

  /deep/ .el-table th.el-table__cell>.cell {
    padding-right: 5px
  }
}

.content {
  width: 100%;
  height: 100%;
}

.btnDesign {
  margin: 20px 56px;
}

.middle {
  position: relative;
  left: -8px;
  top: -20px;
  font-size: 16px;
}

.top {
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  align-items: center
}
</style>

